import React, { useState, useRef, useEffect } from "react";
import "./portfolio.css";
import { MdArrowForward } from "react-icons/md";
// import HorizontalVideo from "./image/cameraManVedio.mp4";
import HorizontalVideo from "./image/PortfolioSectionVideo.mp4";
import VerticalVideo from "./image/PortfolioSectionVideoMobile.mp4";
import { countries } from "countries-list";
import PopUp from "../popUp";
import { sendPortfolioMail } from "../../utils/sendPortfolioMail";

const Portfolio = ({ prefilledData }) => {
  const [selectedSlider, setSelectedSlider] = useState(null);
  const [sliderPositions, setSliderPositions] = useState([0, 0, 0]);
  const [containerWidth, setContainerWidth] = useState(0);
  const [videoSource, setVideoSource] = useState(HorizontalVideo); // Track the video source dynamically
  const isDragging = useRef(false);
  const initialMouseX = useRef(0);
  const currentSliderIndex = useRef(null);
  const sliderItemRef = useRef(null);
  const formRef = useRef(null);
  const [isPopUpVisible, setIsPopUpVisible] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    country: "",
  });
  useEffect(() => {
    console.log("form data:", formData);
  }, [formData]);
  useEffect(() => {
    if (prefilledData) {
      console.log("prefilled data:", prefilledData);
      setFormData(prefilledData); // Ensure this triggers a new state update
    }
  }, [prefilledData]);
  const sliderNames = [
    "Event Shoot",
    "Graphic Designing",
    "Video Editing",
    // "Web Development",
  ];

  const sliderTexts = [
    "*Receive our Event Shoot Portfolio instantly on your E-mail and WhatsApp just share your details!",
    "*Receive our Graphic Designing Portfolio instantly on your E-mail and WhatsApp just share your details!",
    "*Receive our Video Editing Portfolio instantly on your E-mail and WhatsApp just share your details!",
    // "*Receive our Web Development Portfolio instantly on your E-mail and WhatsApp just share your details!",
  ];

  const sliderHeadings = [
    { main: "FILL & GET", sub: "EVENT SHOOT PORTFOLIO" },
    { main: "FILL & GET", sub: "GRAPHIC DESIGNING PORTFOLIO" },
    { main: "FILL & GET", sub: "VIDEO EDITING PORTFOLIO" },
    // { main: "FILL & GET", sub: "WEB DEVELOPMENT PORTFOLIO" },
  ];

  const togglePopUp = () => setIsPopUpVisible(!isPopUpVisible);

  const handleInputChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };
  // const handleFormSubmit = (e) => {
  //   e.preventDefault();
  //   setIsSubmitted(true);
  //   setTimeout(() => {
  //     setIsSubmitted(false);
  //   }, 2000); // Hide success message after 2 seconds
  // };

  // Handle Video Source Based on Screen Size
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (selectedSlider === null) {
      alert("Please select a portfolio service by dragging the arrow.");
      return;
    }

    const mobileInput = document.getElementById("mobile");

    // Validate mobile number length
    if (formData.mobile.length !== 10) {
      mobileInput.setCustomValidity("Mobile number must be exactly 10 digits.");
      mobileInput.reportValidity();
      return;
    } else {
      mobileInput.setCustomValidity("");
    }

    try {
      // Send email with formData (no query field needed here)
      // await sendPortfolioMail(formData);
      await sendPortfolioMail({
        ...formData,
        service: sliderNames[selectedSlider], // Dynamically attach selected service
      });
      setIsSubmitted(true);
      setTimeout(() => {
        setIsSubmitted(false);
      }, 2000); // Hide success message after 2 seconds
    } catch (err) {
      console.error("❌ Error during portfolio form submission:", err);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      // console.log("Current Screen Width:", window.innerWidth); // Log screen width
      if (window.innerWidth <= 768) {
        // console.log("Switching to Vertical Video"); // Debug message for vertical video
        setVideoSource(VerticalVideo); // Use vertical video for smaller screens
      } else {
        // console.log("Switching to Horizontal Video"); // Debug message for horizontal video
        setVideoSource(HorizontalVideo); // Use horizontal video for larger screens
      }
      // console.log("Current Video Source:", videoSource); // Log the video source after updating
    };

    handleResize(); // Initial check

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [[videoSource]]);

  useEffect(() => {
    if (sliderItemRef.current) {
      setContainerWidth(sliderItemRef.current.offsetWidth);
    }
    const resizeListener = () => {
      if (sliderItemRef.current) {
        setContainerWidth(sliderItemRef.current.offsetWidth);
      }
    };

    window.addEventListener("resize", resizeListener);
    return () => {
      window.removeEventListener("resize", resizeListener);
    };
  }, []);

  const handleMouseDown = (index, event) => {
    isDragging.current = true;
    initialMouseX.current = event.clientX || event.touches[0].pageX;
    currentSliderIndex.current = index;
  };

  const handleMouseMove = (event) => {
    if (!isDragging.current || currentSliderIndex.current === null) return;

    // Ensure currentSliderIndex is within bounds of sliderPositions
    if (
      currentSliderIndex.current < 0 ||
      currentSliderIndex.current >= (sliderPositions || []).length
    ) {
      console.warn("Invalid slider index:", currentSliderIndex.current);
      return;
    }

    const currentMouseX = event.clientX || event.touches[0].pageX;
    const deltaX = currentMouseX - initialMouseX.current;

    // Ensure sliderPositions is always an array
    setSliderPositions((prevPositions) => {
      if (!Array.isArray(prevPositions) || prevPositions.length === 0) {
        console.warn("Slider positions are not valid:", prevPositions);
        return prevPositions; // Return the current state if positions are invalid
      }
      return prevPositions.map((pos, index) => {
        if (index === currentSliderIndex.current) {
          const newPosition = pos + deltaX;
          // Limit the arrow movement within the container
          return Math.max(0, Math.min(newPosition, containerWidth - 60));
        }
        return pos;
      });
    });
  };

  const handleMouseUp = () => {
    if (!isDragging.current) return;

    const sliderIndex = currentSliderIndex.current;

    // If the slider is dragged back to left
    if (sliderPositions[sliderIndex] === 0) {
      setVideoSource(HorizontalVideo); // Start the video playback
      setSelectedSlider(null); // Close the form
    } else {
      setSliderPositions((prevPositions) =>
        prevPositions.map((pos, index) =>
          index === sliderIndex ? containerWidth - 60 : 0
        )
      );
      setSelectedSlider(sliderIndex); // Keep the form open when slider reaches the right
    }

    isDragging.current = false;
    currentSliderIndex.current = null;
  };

  const handleClick = (index) => {
    setSliderPositions((prevPositions) =>
      prevPositions.map((pos, i) =>
        i === index ? (pos === 0 ? containerWidth - 60 : 0) : 0
      )
    );
    // setSelectedSlider(index);

    // Toggle the selected slider... if the person clicked the arrow when thw arrow is in the right .. it will automatically move to its initial left position
    if (selectedSlider === index) {
      setSelectedSlider(null); // Deselect the slider if it's already selected
    } else {
      setSelectedSlider(index); // Select the slider

      setTimeout(() => {
        if (window.innerWidth <= 1024 && formRef.current) {
          formRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
          // Add spacing (~50px) after scrolling into view
          setTimeout(() => {
            window.scrollBy({ top: -50, behavior: "smooth" });
          }, 400); // delay must be > scrollIntoView duration
        }
      }, 300); // slight delay for DOM update
    }
  };

  const renderRightContent = () => {
    const countryList = Object.values(countries);

    if (selectedSlider === null) {
      return (
        <div className="video-container">
          {videoSource === VerticalVideo ? (
            <video
              key={VerticalVideo}
              autoPlay
              muted
              loop
              className="portfolio-video"
            >
              <source src={VerticalVideo} type="video/mp4" />
            </video>
          ) : (
            <video
              key={HorizontalVideo}
              autoPlay
              muted
              loop
              className="portfolio-video"
            >
              <source src={HorizontalVideo} type="video/mp4" />
            </video>
          )}
        </div>
      );
    }

    return (
      // <div className="complete-form">
      <div className="complete-form" ref={formRef}>
        <h3 className="formHeading-portfolio">
          <span className="heading1-form">
            {sliderHeadings[selectedSlider].main}
          </span>
          <span className="heading2-form">
            {sliderHeadings[selectedSlider].sub}
          </span>
        </h3>
        <form className="contact-form-portfolio" onSubmit={handleFormSubmit}>
          <div className="form-row-portfolio">
            <div className="form-group-portfolio">
              <input
                type="text"
                placeholder="Name*"
                required
                value={formData.name}
                onChange={(e) => handleInputChange("name", e.target.value)}
                onInput={(e) => {
                  const allowedCharacters = /^[a-zA-Z\s]*$/;
                  if (!allowedCharacters.test(e.target.value)) {
                    e.target.value = e.target.value.slice(0, -1);
                  }
                }}
              />
            </div>
            <div className="form-group-portfolio">
              <input
                id="mobile"
                type="tel"
                placeholder="Mobile Number*"
                required
                maxLength="10"
                onChange={(e) => handleInputChange("mobile", e.target.value)}
                onInput={(e) => {
                  const allowedCharacters = /^[0-9]*$/;
                  if (!allowedCharacters.test(e.target.value)) {
                    e.target.value = e.target.value.slice(0, -1);
                  }
                }}
              />
            </div>
          </div>
          <div className="form-row-portfolio">
            <div className="form-group-portfolio">
              <input
                type="email"
                placeholder="Email Address*"
                required
                onChange={(e) => handleInputChange("email", e.target.value)}
              />
            </div>
            <div className="form-group-portfolio">
              <select
                className="select-option"
                required
                onChange={(e) => handleInputChange("country", e.target.value)}
              >
                <option value="">Country*</option>
                {countryList.map((country, index) => (
                  <option key={index} value={country.name}>
                    {country.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="form-row-portfolio">
            <button className="submit" type="submit">
              SUBMIT
            </button>
            <button className="query" type="button" onClick={togglePopUp}>
              ANY QUERY?
            </button>
          </div>
        </form>
        {/* Success Popup */}
        {isSubmitted && (
          <div className="success-popup">Form submitted successfully!</div>
        )}
        <h3 className="drag-info">{sliderTexts[selectedSlider]}</h3>
      </div>
    );
  };

  return (
    <div
      className="portfolio-content"
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onTouchMove={handleMouseMove}
      onTouchEnd={handleMouseUp}
      id="portfolio"
    >
      <div className="left">
        <div className="portfolio-heading">PORTFOLIO</div>
        <div className="sliders">
          {sliderNames.map((name, index) => (
            <div
              key={index}
              className={`slider-item ${
                selectedSlider === index ? "active" : ""
              }`}
              ref={sliderItemRef}
              onClick={() => handleClick(index)}
            >
              <div
                className="arrow-div"
                style={{ transform: `translateX(${sliderPositions[index]}px)` }}
                onMouseDown={(e) => handleMouseDown(index, e)}
                onTouchStart={(e) => handleMouseDown(index, e)}
              >
                <MdArrowForward
                  className={`arrow ${selectedSlider === index ? "move" : ""}`}
                />
              </div>
              <div className="arrow-text">{name}</div>
            </div>
          ))}
          <p>*Drag Arrow to get portfolio</p>
        </div>
      </div>
      <div className="right">{renderRightContent()}</div>
      {/* {isPopUpVisible && <PopUp onClose={togglePopUp} />} */}
      {isPopUpVisible && (
        <div className="popup-overlay">
          {/* <PopUp togglePopUp={togglePopUp}  /> */}
          <PopUp togglePopUp={togglePopUp} prefilledData={formData} />
        </div>
      )}
    </div>
  );
};

export default Portfolio;
